module.exports = __webpack_public_path__ + "img/icon_skip.7637779c.svg";